<template>
	<form class="form form--resource form-resource" @submit.prevent="submitForm(fields)">
		<div class="form__loader" v-if="loading">
			<loading-spinner />
		</div>

		<div class="form-section">
			<div class="form-row form-row--col-2-1">
				<text-field class="form__field" type="text" label="Icon (Ion)" v-model="fields.icon" :required="false" />
				<text-field class="form__field" label="Name" v-model="fields.name" :required="true" autocomplete="nope" />
			</div>
			<div class="form-row">
				<text-field class="form__field" type="url" label="Website" v-model="fields.url" :required="true" />
			</div>
			<div class="form-row form-row--col-2">
				<select-field class="form__field" label="Access" v-model="fields.access" :options="resourceAccess" />
				<select-field class="form__field" label="Category" v-model="fields.category" :options="resourceCategory" />
				<select-field class="form__field" label="Type" v-model="fields.type" :options="resourceType" />
				<select-field class="form__field" label="Status" v-model="fields.status" :options="resourceStatus" />
			</div>

			<div class="form-row">
				<text-area class="form__field" label="Description" v-model="description" />
			</div>

			<div class="form-row" v-if="fields.access == 'alist'">
				<text-area class="form__field" label="Non A-List Description" v-model="descriptionAlt" />
			</div>

			<h2 class="form-section__title">Settings</h2>
			<div class="form-row form-row--col-2">
				<text-field class="form__field" label="Contact Email" v-model="fields.settings.contactEmail" />
				<text-field class="form__field" label="Tracking Field" v-model="fields.settings.trackingField" />
			</div>

			<div class="form__actions form__actions--horizontal">
				<a-button class="button--primary form__action" type="submit" :disabled="loading">
					{{ fields.resourceId ? `Update` : `Create` }} Resource
				</a-button>
			</div>
		</div>
	</form>
</template>

<script>
import AButton from '@/components/AButton'
import LoadingSpinner from '@/components/LoadingSpinner'
import SelectField from '@/components/SelectField'
import TextField from '@/components/TextField'
import TextArea from '@/components/TextArea'
import { ResourceAccess, ResourceStatus, ResourceType, ResourceCategory } from '@/lib/enums'
import { get, pick } from 'lodash'

export default {
	name: 'FormResource',
	components: {
		AButton,
		LoadingSpinner,
		SelectField,
		TextField,
		TextArea
	},
	props: {
		loading: Boolean,
		resource: {
			type: Object,
			default: () => ({}),
		},
	},
	data: () => ({
		defaults: {
			settings: {},
		},
		fields: {},
		isLoading: false,
	}),
	unmounted() {
		this.$store.dispatch('resource/unset')
	},
	computed: {
		resourceStatus() {
			let status = []
			for (const key in ResourceStatus) {
				status.push({
					value: key,
					label: ResourceStatus[key],
				})
			}

			return status
		},
		resourceType() {
			let type = []
			for (const key in ResourceType) {
				type.push({
					value: key,
					label: ResourceType[key],
				})
			}

			return type
		},
		resourceAccess() {
			let access = []
			for (const key in ResourceAccess) {
				access.push({
					value: key,
					label: ResourceAccess[key],
				})
			}

			return access
		},
		resourceCategory() {
			let category = []
			for (const key in ResourceCategory) {
				category.push({
					value: key,
					label: ResourceCategory[key],
				})
			}

			return category
		},
		description: {
			get() {
				const parser = new DOMParser()
				const doc = parser.parseFromString(this.fields.description, 'text/html')
				return doc.body.textContent

			},
			set(newValue) {
				this.fields.description = newValue
			},
		},
		descriptionAl: {
			get() {
				const parser = new DOMParser()
				const doc = parser.parseFromString(this.fields.descriptionAlt, 'text/html')
				return doc.body.textContent

			},
			set(newValue) {
				this.fields.descriptionAlt = newValue
			},
		},
	},
	methods: {
		submitForm(fields) {
			if (fields.resourceId) {
				this.isLoading = true
				this.$store.dispatch('resource/update', { resourceId: fields.resourceId, data: fields })
					.then(() => {
						this.$notice(`Resource updated!`)
					})
					.catch((error) => {
						this.$notice(`ERROR: ${error.message || error}`)
					})
					.finally(() => {
						this.isLoading = false
					})
			} else {
				this.isLoading = true
				this.$store.dispatch('resource/create', fields)
					.then(() => {
						this.$notice(`Resource created!`)
					})
					.catch((error) => {
						this.$notice(`ERROR: ${error.message || error}`)
					})
					.finally(() => {
						this.isLoading = false
					})
			}
		},
	},
	watch: {
		resource: {
			immediate: true,
			handler: function (appProp) {
				this.fields = {
					...this.defaults,
					...appProp,
					...pick(appProp, ['resourceId', 'createdBy', 'createdByName', 'dateCreated', 'dateModified', 'modifiedBy', 'modifiedByName', 'name', 'settings', 'status', 'type', 'access', 'category', 'url', 'description', 'descriptionAlt', 'icon',]),
				}
			},
		},
	},
}
</script>

<style scoped lang="scss">
</style>
